module.exports = __webpack_public_path__ + "img/account-auth-logo.b7d4be67.svg";